import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Protected from "@/components/Protected";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PublicPlan from "@/pages/PublicPlan";
import Community from "@/pages/Community";
import Dashboard from "@/pages/Dashboard";
import ExerciseLibrary from "@/pages/ExerciseLibrary";
import ExerciseDetail from "@/pages/ExerciseDetail";
import PlanBuilder from "@/pages/PlanBuilder";
import WorkoutLog from "@/pages/WorkoutLog";
import Profile from "@/pages/Profile";
import AIPlanGenerator from "@/pages/AIPlanGenerator";
import Tutorial from "@/pages/Tutorial";
import Assessment from "@/pages/Assessment";
import SquadDetail from "@/pages/SquadDetail";
import AdminAnalytics from "@/pages/AdminAnalytics";
import WorkoutSession from "@/pages/WorkoutSession";

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  return user ? <Navigate to="/dashboard" replace /> : <Landing />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/p/:slug" element={<PublicPlan />} />
          <Route path="/community" element={<Community />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/library" element={<Protected><ExerciseLibrary /></Protected>} />
          <Route path="/exercises" element={<Navigate to="/library" replace />} />
          <Route path="/exercise/:id" element={<Protected><ExerciseDetail /></Protected>} />
          <Route path="/builder" element={<Protected><PlanBuilder /></Protected>} />
          <Route path="/builder/:id" element={<Protected><PlanBuilder /></Protected>} />
          <Route path="/plans/:id" element={<Protected><WorkoutLog /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/ai" element={<Protected><AIPlanGenerator /></Protected>} />
          <Route path="/tutorial" element={<Protected><Tutorial /></Protected>} />
          <Route path="/assessment" element={<Protected><Assessment /></Protected>} />
          <Route path="/squads/:id" element={<Protected><SquadDetail /></Protected>} />
          <Route path="/admin/analytics" element={<Protected><AdminAnalytics /></Protected>} />
          <Route path="/session/:id/:weekIndex/:day" element={<Protected><WorkoutSession /></Protected>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
